import { PlusOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Button, Drawer } from 'antd';
import React from 'react';

interface IProps {
  loading?: boolean;
  hideButton?: boolean;
  hideButtonTitle?: boolean;
  hideButtonIcon?: boolean;
  buttonIcon?: React.ReactNode;
  drawerTitle?: string | React.ReactNode;
  buttonTitle?: string;
  placement?: 'right' | 'left' | 'bottom' | 'top';
  type?: 'default' | 'link' | 'text' | 'primary' | 'dashed' | undefined;
  size?: 'large' | 'middle' | 'small';
  drawerWidth?: number;
  visible?: boolean;
  forceRender?: boolean | undefined;
  closable?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  onClose?: (
    e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element> | KeyboardEvent
  ) => void | undefined;
  onClick?: ((e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => void) | undefined;
  extra?: React.ReactNode;
  footer?: React.ReactNode;
  buttonStyle?: React.CSSProperties;
  styles?: Record<string, React.CSSProperties>;
}

export const DrawerButton: React.FC<IProps> = ({
  loading = false,
  hideButtonTitle = false,
  hideButton = false,
  hideButtonIcon = false,
  buttonIcon = <PlusOutlined />,
  drawerTitle = 'Create new',
  buttonTitle = 'New',
  placement = 'right',
  type = 'primary',
  size = 'middle',
  drawerWidth = 1200,
  visible = false,
  disabled = false,
  forceRender = false,
  closable = false,
  onClose,
  onClick,
  children,
  extra,
  footer,
  buttonStyle,
  styles,
}) => {
  return (
    <>
      {!hideButton && (
        <Button
          size={size}
          type={type}
          disabled={disabled}
          icon={!hideButtonIcon && buttonIcon}
          onClick={onClick}
          style={buttonStyle}
        >
          {!hideButtonTitle && buttonTitle}
        </Button>
      )}
      <Drawer
        loading={loading}
        footer={footer}
        forceRender={forceRender}
        title={typeof drawerTitle === 'string' ? L(drawerTitle) : drawerTitle}
        styles={{ ...styles, wrapper: { ...styles?.wrapper, width: drawerWidth } }}
        placement={placement}
        onClose={onClose}
        open={visible}
        closable={closable}
        extra={extra}
      >
        {children}
      </Drawer>
    </>
  );
};
